import React, { useState } from "react";
import OwLabel from "../../../shared/OwLabel/OwLabel";
import { DashboardOrderEntryDetails } from "../../DashboardOrderEntryDetails/DashboardOrderEntryDetails";
import UIService from "../../../../services/UIService";
import { OrderDetails } from "../DashboardOrderEntry";

type Props = {
    updateOrderDetails: (details: OrderDetails) => void;
};

export const DashboardEntryDetailsWidget = (props: Props) => {
    const isMainViewLight = UIService.isMainViewLight();

    const [detailsEditMode, setDetailsEditMode] = useState(false);

    const toggleDetailsEditMode = () => {
        setDetailsEditMode(!detailsEditMode);
    };

    return (
        <div className={"DashboardEntryDetailsWidget card col-3 .g-0 " + (!isMainViewLight ? "text-white bg-dark" : "")}>
            <div className={"d-flex justify-content-between font-weight-bold card-header"}>
                <OwLabel title={"details"} />

                <OwLabel title={detailsEditMode ? "save" : "edit"} fn={toggleDetailsEditMode} />
            </div>
            <div>
                <div className={"card-body"}>
                    <DashboardOrderEntryDetails editMode={detailsEditMode} updateOrderDetails={props.updateOrderDetails} />
                </div>
            </div>
        </div>
    );
};
